import { Box, Button, Alert } from '@mui/material';

const ErrorLoading = props => {
    return (
        <Box
            sx={{
                margin: 'auto',
                marginTop: '24px',
                maxWidth: '1200px',
                textAlign: 'center',
            }}
        >
            <Alert severity="error" elevation={6} variant="filled">
                {props.text}
            </Alert>
            <Button
                sx={{ m: 1 }}
                variant="contained"
                color="secondary"
                onClick={() => props.dispatchCall()}
            >
                Refresh
            </Button>
        </Box>
    );
};

export default ErrorLoading;
